import { loadData, saveData } from "../../Utils/localStorage";
import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_ID
} from "./Auth.actionType";

const initState = {
  isLogin: loadData("vendorId") ? true : false,
  // isLogin: true,

  token: loadData("token") || "",
  isLoading: false,
  isError: false,
  vendorId: loadData("vendorId") || "",
  vendorName: loadData("vendorName") || "",
  userId: loadData("userId") || "",
};

export const Auth_reducer = (state = initState, { type, payload }) => {
  switch (type) {
    case LOGIN_REQUEST:
      return {
        ...state,
      };
    case LOGIN_SUCCESS:
      saveData("vendorId", payload.vendorId);
      saveData("vendorName", payload.vendorName);
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLogin: true,
        token: payload.vendorId,
        vendorId: payload.vendorId,
        vendorName: payload.vendorName
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case LOGOUT:
      saveData("vendorId", "");
      saveData("vendorName", "");
      localStorage.clear();
      return {
        ...state,
        isLoading: false,
        isError: false,
        token: "",
        isLogin: false,
        vendorId: "",
      };
      case USER_ID:
      saveData("userId", payload);
      return {
        ...state,
        userId: payload,
      };
    default:
      return state;
  }
};
